'use client';

import React from 'react';
import type { LandscapeRenders, Artworkvideo, Artworkimage } from '@/types';
import { lexicalStateToHtml } from '@/lib/utils/lexical-to-html';

import { Gallery } from '@/components/ui/catalog/landscape/ui/gallery';

interface LandscapeRenderProps {
  layout: LandscapeRenders;
}

export const Landscape_Renders: React.FC<LandscapeRenderProps> = ({ layout }) => {
  return (
    <section className="w-full">
      <div className="p-[15px] rounded-md bg-white mb-[12px] flex flex-col justify-between relative pt-4">
        <div className="content-section">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 font-mono text-[10px] fade-in-up">
            <div>
              <div className="mt-0">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <h3 className="text-[10px] font-mono text-gray-400 mb-2">[ {layout.leftTitle} ]</h3>
                    <div
                      className="space-y-4 text-[10px] leading-relaxed [&>p]:mb-2"
                      dangerouslySetInnerHTML={{
                        __html: layout.leftContent
                          ? lexicalStateToHtml(layout.leftContent)
                          : '',
                      }}
                    />
                  </div>
                  <div>
                    <h3 className="text-[10px] font-mono text-gray-400 mb-2">[ {layout.rightTitle} ]</h3>
                    <div
                      className="space-y-4 text-[10px] leading-relaxed [&>p]:mb-2"
                      dangerouslySetInnerHTML={{
                        __html: layout.rightContent
                          ? lexicalStateToHtml(layout.rightContent)
                          : '',
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div>
              {/* TODO: type properly - LandscapeRenders uses (number | Video)[] but Gallery expects Artworkvideo[] */}
              <Gallery videos={layout.videos as unknown as Artworkvideo[]} images={layout.images as unknown as Artworkimage[]} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
